<template>
  <div>
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <h1 class="h2 text-muted">MAPPING ENGINE / INSURER TRANSLATION MAP</h1>
    </div>
    <h6>Filter Map Entries</h6>
    <form class="row g-3">
      <div class="col-md-3">
        <input
          type="text"
          class="form-control"
          placeholder="From Description"
          v-model="qdescSearchQuery"
          v-on:input="debounceInput"
        />
      </div>
      <div class="col-md-1" style="width: 12.499999995%">
        <input
          type="text"
          class="form-control"
          placeholder="From Code"
          v-model="qcodeSearchQuery"
          v-on:input="debounceInput"
        />
      </div>
      <div class="col-md-1" style="width: 12.499999995%">
        <input
          type="text"
          class="form-control"
          placeholder="To Code"
          v-model="icodeSearchQuery"
          v-on:input="debounceInput"
        />
      </div>
      <div class="col-md-3">
        <input
          type="text"
          class="form-control"
          placeholder="To Description"
          v-model="idescSearchQuery"
          v-on:input="debounceInput"
        />
      </div>
      <div class="col-md-2" style="width: 20.8333333%">
        <select
          class="form-select"
          v-model="inameSearchQuery"
          v-on:input="debounceInput"
        >
          <option value="" disabled>by Insurer</option>
          <option
            v-for="insurer in insurers"
            v-bind:value="insurer.insurer_name"
            :key="insurer.insurer_name"
          >
            {{ insurer.insurer_name }}
          </option>
        </select>
      </div>
      <div class="col-md-1" style="width: 4.16666667%">
        <button type="button" class="btn" @click="clearSearch">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-x-circle"
            viewBox="0 0 16 16"
          >
            <path
              d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
            />
            <path
              d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </button>
      </div>
    </form>
    <form class="row g-3 mt-3 px-3">
      <div class="col-md-1" style="width: 4.16666667%">
        <input
          class="form-check-input"
          type="checkbox"
          @change="selectAll"
          v-model="allSelected"
        />
      </div>
      <div class="col-md-2" style="width: 23%">
        <h6>Description</h6>
      </div>
      <div class="col-md-1" style="width: 13.5%">
        <h6>From</h6>
      </div>
      <div class="col-md-1" style="width: 12%">
        <h6>To</h6>
      </div>
      <div class="col-md-3" style="width: 26.5%">
        <h6>Description</h6>
      </div>
      <div class="col-md-2">
        <h6>Insurer</h6>
      </div>
    </form>
    <div v-if="loading" class="spinner-border text-primary" />
    <div v-else class="accordion accordion-flush" id="accordionFlushExample">
      <div
        class="accordion-item"
        v-for="(ruleset, index) in resultQuery"
        :key="index"
      >
        <!-- <h2 class="accordion-header"> -->
        <div class="d-flex" style="padding-left: 1rem">
          <div class="col-md-1 align-self-center" style="width: 4.16666667%">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="selected"
              v-bind:value="ruleset.insurer_code_map_id"
              :key="ruleset.insurer_code_map_id"
              @click="select"
            />
          </div>
          <button
            class="accordion-button collapsed col-md-11"
            type="button"
            data-bs-toggle="collapse"
            :data-bs-target="'#collapse' + ruleset.insurer_code_map_id"
            aria-expanded="false"
            aria-controls="flush-collapseOne"
            style="padding: 1rem 0rem; width: 94%"
          >
            <div
              class="col-md-2"
              style="width: 24%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right:5%"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              :title="ruleset.quotey_description"
            >
              {{ ruleset.quotey_description }}
            </div>
            <div
              class="col-md-1"
              style="width: 14.5%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right:5%"
            >
              {{ ruleset.quotey_code }}
            </div>
            <div
              class="col-md-1"
              style="width: 13%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right:5%"
            >
              {{ ruleset.insurer_code }}
            </div>
            <div
              class="col-md-3"
              style="width: 28%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right:5%"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              :title="ruleset.insurer_description"
            >
              {{ ruleset.insurer_description }}
            </div>
            <div
              class="col-md-2"
              style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right: 5%;"
            >
              {{ ruleset.insurer_name }}
            </div>
          </button>
        </div>
        <!-- </h2> -->
        <div
          :id="'collapse' + ruleset.insurer_code_map_id"
          class="accordion-collapse collapse mt-3 px-3"
          aria-labelledby="flush-headingOne"
          data-bs-parent="#accordionFlushExample"
        >
          <div class="row g-3 mt-3" v-if="updateError">
            <div class="col-md-1" style="width: 4.16666667%"></div>
            <div class="col-md-11 alert alert-danger" role="alert">
              Either the Quotey/Insurer code is empty or this Quotey code is
              already present. Please check.
            </div>
          </div>
          <div class="row g-3">
            <div class="col-md-3"></div>
            <div class="col-md-3">
              From
            </div>
            <div class="col-md-3" style="padding-right: inherit;">
              To
            </div>
            <div class="col-md-1">
              Insurer
            </div>
          </div>
          <div class="row g-3 mt-1">
            <div class="col-md-1" style="width: 4.16666667%"></div>
            <div
              class="col-md-2"
              style="width: 20.8333333%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right: inherit;"
            >
              Quotey Answer Code
            </div>
            <div class="col-md-3" style="padding-right: 30px;">
              <input
                type="text"
                class="form-control"
                :id="'updatedQuoteyCode' + ruleset.insurer_code_map_id"
                :value="ruleset.quotey_code"
              />
            </div>
            <div class="col-md-3" style="padding-right: 30px;">
              <input
                type="text"
                class="form-control"
                :id="'updatedInsurerCode' + ruleset.insurer_code_map_id"
                :value="ruleset.insurer_code"
              />
            </div>
            <div class="col-md-2">
              <select
                class="form-select"
                :id="'updatedInsurerName' + ruleset.insurer_code_map_id"
                v-model="ruleset.insurer_id"
              >
                <option
                  v-for="insurer in insurers"
                  :key="insurer.insurer_id"
                  v-bind:value="insurer.insurer_id"
                >
                  {{ insurer.insurer_name }}
                </option>
              </select>
            </div>
          </div>
          <div class="row g-3 mt-1 mb-3">
            <div class="col-md-1" style="width: 4.16666667%"></div>
            <div
              class="form-group col-md-5"
              style="width: 45.8333333%; padding-right: 30px;"
            >
              <label class="mb-2" for="comment">Description</label>
              <textarea
                class="form-control"
                rows="4"
                :id="'updatedQuoteyDesc' + ruleset.insurer_code_map_id"
                :value="ruleset.quotey_description"
              ></textarea>
            </div>
            <div
              class="form-group col-md-5"
              style="width: 45.8333333%; padding-right: 30px;"
            >
              <label class="mb-2" for="comment">Description</label>
              <textarea
                class="form-control"
                rows="4"
                :id="'updatedInsurerDesc' + ruleset.insurer_code_map_id"
                :value="ruleset.insurer_description"
              ></textarea>
            </div>
            <div class="form-group" style="text-align:right;">
              <button
                class="btn btn-secondary"
                type="button"
                @click="cancelUpdate(ruleset.insurer_code_map_id)"
              >
                Cancel
              </button>
              <div class="divider" />
              <button
                class="btn btn-primary"
                type="button"
                @click="updateCodeMap(ruleset)"
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="card collapse collapsing mt-3"
      id="addRow"
      style="min-width: 100%"
    >
      <form
        id="form_id"
        class="row g-3 needs-validation"
        novalidate
        @submit.prevent="addCodeMap"
      >
        <div class="row g-3 mt-3" v-if="addError">
          <div class="col-md-1" style="width: 4.16666667%"></div>
          <div class="col-md-11 alert alert-danger" role="alert">
            Error: {{ addErrorReason }}
          </div>
        </div>
        <div class="row g-3">
          <div class="col-md-3"></div>
          <div class="col-md-3">
            From
          </div>
          <div class="col-md-3" style="padding-right: inherit;">
            To
          </div>
          <div class="col-md-1">
            Insurer
          </div>
        </div>
        <div class="row g-3 mt-1">
          <div class="col-md-1" style="width: 4.16666667%"></div>
          <div
            class="col-md-2"
            style="width: 20.8333333%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right: inherit;"
          >
            Quotey Answer Code
          </div>
          <div class="col-md-3" style="padding-right: 30px;">
            <input
              type="text"
              class="form-control"
              v-model="new_quotey_code"
              required
            />
            <div class="invalid-feedback">
              Quotey Code is required!
            </div>
          </div>
          <div class="col-md-3" style="padding-right: 30px;">
            <input
              type="text"
              class="form-control"
              v-model="new_insurer_code"
              required
            />
            <div class="invalid-feedback">
              Insurer Code is required!
            </div>
          </div>
          <div class="col-md-2">
            <select class="form-select" v-model="new_insurer_id" required>
              <option
                v-for="insurer in insurers"
                v-bind:value="insurer.insurer_id"
                :key="insurer.insurer_id"
              >
                {{ insurer.insurer_name }}
              </option>
            </select>
            <div class="invalid-feedback">
              Insurer Name is required!
            </div>
          </div>
        </div>
        <div class="row g-3 mt-1 mb-3">
          <div class="col-md-1" style="width: 4.16666667%"></div>
          <div
            class="form-group col-md-5"
            style="width: 45.8333333%; padding-right: 30px;"
          >
            <label class="mb-2" for="comment">Description</label>
            <textarea
              class="form-control"
              rows="4"
              v-model="new_quotey_description"
            ></textarea>
          </div>
          <div
            class="form-group col-md-5"
            style="width: 45.8333333%; padding-right: 30px;"
          >
            <label class="mb-2" for="comment">Description</label>
            <textarea
              class="form-control"
              rows="4"
              id="comment"
              v-model="new_insurer_description"
            ></textarea>
          </div>
          <div class="form-group" style="text-align:right;">
            <button
              class="btn btn-secondary"
              type="button"
              @click="cancelAddRow"
              data-bs-toggle="collapse"
              data-bs-target="#addRow"
              aria-expanded="false"
              aria-controls="addRow"
            >
              Cancel
            </button>
            <div class="divider" />
            <button class="btn btn-primary" type="submit">
              Add
            </button>
          </div>
        </div>
      </form>
    </div>
    <div
      class="card collapse collapsing mt-3 mb-4 px-3"
      id="import"
      style="min-width: 100%"
    >
      <div class="flex">
        <button
          type="button"
          class="btn-close mt-2"
          data-bs-toggle="collapse"
          data-bs-target="#import"
          aria-expanded="false"
          aria-controls="import"
          style="float:right;"
          @click="clearImport"
        ></button>
        <h6 class="mt-4">Upload A CSV Map:</h6>
      </div>
      <form id="upload-file">
        <div class="row mb-5 mt-3" v-if="upload">
          <label for="inputGroupFile02" class="col-sm-2 col-form-label"
            >Select a File</label
          >
          <div class="col-sm-5">
            <input
              ref="file"
              type="file"
              class="form-control"
              id="inputGroupFile02"
            />
          </div>
          <div class="col-sm-3">
            <button type="button" class="btn btn-secondary" @click="importCSV">
              Upload
            </button>
          </div>
        </div>
        <div class="mb-4 mt-3" v-else>
          <div class="row" v-if="fileupload">
            <div class="col-sm-2" style="padding-left: 10%;">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                fill="green"
                class="bi bi-check-circle"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                />
                <path
                  d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
                />
              </svg>
            </div>
            <div class="col-sm-10">Your Upload has been completed.</div>
          </div>
          <div class="row" v-else>
            <div class="col-sm-2" style="padding-left: 10%;">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                fill="red"
                class="bi bi-x-circle"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                />
                <path
                  d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                />
              </svg>
            </div>
            <div class="col-sm-10">
              Your file could not be uploaded. Please check.
            </div>
          </div>
          <div class="row" v-if="format">
            <div class="col-sm-2" style="padding-left: 10%;">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                fill="green"
                class="bi bi-check-circle"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                />
                <path
                  d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
                />
              </svg>
            </div>
            <div class="col-sm-10">
              The format of your file appears to be right.
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-sm-2" style="padding-left: 10%;">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                fill="red"
                class="bi bi-x-circle"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                />
                <path
                  d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                />
              </svg>
            </div>
            <div class="col-sm-10">
              The format of your file does not appear to be right. Please check.
            </div>
          </div>
          <div class="row" v-if="entries">
            <div class="col-sm-2" style="padding-left: 10%;">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                fill="green"
                class="bi bi-check-circle"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                />
                <path
                  d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
                />
              </svg>
            </div>
            <div class="col-sm-10">
              {{ numentries }} Entries have been processed.
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-sm-2" style="padding-left: 10%;">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                fill="red"
                class="bi bi-x-circle"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                />
                <path
                  d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                />
              </svg>
            </div>
            <div class="col-sm-10">
              No entries have been processed. Please check.
            </div>
          </div>
          <div
            class="alert alert-danger align-items-center mt-3"
            role="alert"
            v-if="error"
          >
            <div class="d-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                viewBox="0 0 16 16"
                role="img"
                aria-label="Warning:"
              >
                <path
                  d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
              </svg>
              <div>
                Warning: Rows {{ failed_row_list }} have not been processed.
                Either the Insurer Id is wrong or the Quotey code for that
                insurer is already present. Please check.
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="removeModal"
      tabindex="-1"
      aria-labelledby="removeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Remove Selected Rows
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="confirmDelete = ''"
            ></button>
          </div>
          <div class="modal-body">
            <div
              class="alert alert-danger d-flex align-items-center"
              role="alert"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                viewBox="0 0 16 16"
                role="img"
                aria-label="Warning:"
              >
                <path
                  d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
              </svg>
              <div>
                Warning: This action cannot be un-done!
              </div>
            </div>
            <div class="row mb-3">
              <label for="confirmDelete" class="col-sm-8 col-form-label"
                >Are you sure you want to remove selected rows? (Type yes to
                confirm)</label
              >
              <div class="col-sm-4">
                <input
                  class="form-control"
                  id="confirmDelete"
                  v-model="confirmDelete"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="confirmDelete = ''"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="deleteRows"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="mt-4 mb-5 px-3"
      style="display: flex;
  justify-content: space-between;"
    >
      <button
        type="button"
        class="btn btn-secondary"
        data-bs-toggle="modal"
        data-bs-target="#removeModal"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-trash"
          viewBox="0 0 16 16"
        >
          <path
            d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
          />
          <path
            fill-rule="evenodd"
            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
          />
        </svg>

        Remove Selected Rows
      </button>
      <div style="text-align:right;">
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-toggle="collapse"
          data-bs-target="#addRow"
          aria-expanded="false"
          aria-controls="addRow"
        >
          Add Row
        </button>
        <div class="divider" />
        <button type="button" class="btn btn-secondary" @click="exportCSV">
          Export CSV
        </button>
        <div class="divider" />
        <button
          type="button"
          @click="clearImport"
          class="btn btn-secondary"
          data-bs-toggle="collapse"
          data-bs-target="#import"
          aria-expanded="false"
          aria-controls="import"
        >
          Import CSV
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import * as $ from "jquery";
import config from "../config";
import _ from "lodash";
export default {
  data() {
    return {
      awaitingSearch: false,
      resultQuery: [],
      addRow: false,
      addError: false,
      addErrorReason: "",
      upload: true,
      fileupload: false,
      format: false,
      entries: false,
      numentries: 0,
      updateError: false,
      insurers: [],
      rulesets: [],
      selected: [],
      confirmDelete: "",
      allSelected: false,
      new_insurer_id: "",
      new_quotey_code: "",
      new_insurer_code: "",
      new_quotey_description: "",
      new_insurer_description: "",
      qdescSearchQuery: "",
      qcodeSearchQuery: "",
      icodeSearchQuery: "",
      idescSearchQuery: "",
      inameSearchQuery: "",
      error: false,
      failed_row_list: [],
      loading: true,
    };
  },
  methods: {
    debounceInput: _.debounce(function(e) {
      console.log(e.target.value);
      this.resultQuery = this.filterMap();
    }, 500),
    filterMap() {
      if (
        this.qdescSearchQuery ||
        this.qcodeSearchQuery ||
        this.icodeSearchQuery ||
        this.idescSearchQuery ||
        this.inameSearchQuery
      ) {
        return this.rulesets.filter((ruleset) => {
          return (
            this.qdescSearchQuery
              .toLowerCase()
              .split(" ")
              .every((v) =>
                ruleset.quotey_description.toLowerCase().includes(v)
              ) &&
            this.qcodeSearchQuery
              .split(" ")
              .every((v) => ruleset.quotey_code.includes(v)) &&
            this.icodeSearchQuery
              .split(" ")
              .every((v) => ruleset.insurer_code.includes(v)) &&
            this.idescSearchQuery
              .split(" ")
              .every((v) =>
                ruleset.insurer_description.toLowerCase().includes(v)
              ) &&
            (this.inameSearchQuery === ruleset.insurer_name ||
              this.inameSearchQuery === "")
          );
        });
      } else {
        return this.rulesets;
      }
    },
    async addCodeMap() {
      console.log(this.new_insurer_id);
      const form = document.getElementById("form_id");
      if (form.checkValidity()) {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              quotey_code: this.new_quotey_code,
              insurer_code: this.new_insurer_code,
              quotey_description: this.new_quotey_description,
              insurer_description: this.new_insurer_description,
              insurer_id: this.new_insurer_id,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/add_code_map",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Added"]) {
          this.getDeets();
          this.addRow = false;
          this.new_quotey_code = "";
          this.new_insurer_code = "";
          this.new_quotey_description = "";
          this.new_insurer_description = "";
          this.new_insurer_id = "";
          this.addError = false;
          $("#addRow").collapse("hide");
          var form2 = $("#form_id")[0];
          $(form2).removeClass("was-validated");
          form2.reset();
        } else {
          this.addError = true;
          this.addErrorReason = data["reason"];
        }
      }
    },
    cancelAddRow() {
      this.new_insurer_id = "";
      this.new_quotey_code = "";
      this.new_insurer_code = "";
      this.new_quotey_description = "";
      this.new_insurer_description = "";
      this.addError = false;
      this.addErrorReason = "";
      var form = $("#form_id")[0];
      $(form).removeClass("was-validated");
      // form.reset();
    },
    async updateCodeMap(ruleset) {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            insurer_code_map_id: ruleset.insurer_code_map_id,
            quotey_code: $(
              "#updatedQuoteyCode" + ruleset.insurer_code_map_id
            ).val(),
            insurer_code: $(
              "#updatedInsurerCode" + ruleset.insurer_code_map_id
            ).val(),
            quotey_description: $(
              "#updatedQuoteyDesc" + ruleset.insurer_code_map_id
            ).val(),
            insurer_description: $(
              "#updatedInsurerDesc" + ruleset.insurer_code_map_id
            ).val(),
            insurer_id: $(
              "#updatedInsurerName" + ruleset.insurer_code_map_id
            ).val(),
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/update_code_map",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      if (data["Added"]) {
        this.getDeets();
        $("#collapse" + ruleset.insurer_code_map_id).collapse("hide");
        this.updateError = false;
      } else {
        this.updateError = true;
      }
    },
    cancelUpdate(id) {
      this.updateError = false;
      this.getDeets();
      $("#collapse" + id).collapse("hide");
    },
    selectAll() {
      this.selected = [];
      // this.allSelected = event.target.value;
      console.log(this.allSelected);
      if (this.allSelected) {
        for (var ruleset in this.rulesets) {
          this.selected.push(this.rulesets[ruleset].insurer_code_map_id);
        }
      }
    },
    select() {
      this.allSelected = false;
    },
    async deleteRows() {
      if (this.confirmDelete.toLowerCase() === "yes") {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              insurer_code_map_id: this.selected,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/remove_code_map",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
      }
      location.reload();
    },
    clearSearch() {
      this.qdescSearchQuery = "";
      this.qcodeSearchQuery = "";
      this.icodeSearchQuery = "";
      this.idescSearchQuery = "";
      this.inameSearchQuery = "";
      this.resultQuery = this.filterMap();
    },
    async getDeets() {
      const res = await fetch(config.baseURL + "/get_insurer_code_map", {
        credentials: "include",
      });
      const data = await res.json();
      console.log(data);
      this.rulesets = data;
      this.resultQuery = this.filterMap();
      // console.log(this.rulesets);
    },
    async exportCSV() {
      let csv =
        '"insurer_code_map_id","from_description","from_code","to_code","to_description","insurer_id","insurer_name"\n';
      this.resultQuery.forEach((result) => {
        csv +=
          '"' +
          result.insurer_code_map_id +
          '","' +
          result.quotey_description +
          '","' +
          result.quotey_code +
          '","' +
          result.insurer_code +
          '","' +
          result.insurer_description +
          '","' +
          result.insurer_id +
          '","' +
          result.insurer_name;
        csv += '"\n';
      });

      const anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = "Insurers_Code_Translation_Map.csv";
      anchor.click();
    },
    async importCSV() {
      this.upload = false;
      const filedata = new FormData();
      filedata.append("code_map", this.$refs.file.files.item(0));
      const requestOptions = {
        method: "POST",
        credentials: "include",
        body: filedata,
      };
      const response = await fetch(
        config.baseURL + "/save_code_map_csv",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      this.getDeets();
      if (data) this.fileupload = true;
      if (data["Format"]) this.format = true;
      if (data["Number_of_rows_added"]) {
        this.entries = true;
        this.numentries = data["Number_of_rows_added"];
      }
      if (data.failed_row_list.length !== 0) {
        this.error = true;
        this.failed_row_list = data.failed_row_list;
      }
    },
    clearImport() {
      this.upload = true;
      $("#inputGroupFile02").val("");
      this.fileupload = false;
      this.format = false;
      this.entries = false;
      this.numentries = 0;
      this.error = false;
      this.failed_row_list = [];
    },
  },
  async mounted() {
    this.getDeets();
    const res = await fetch(config.baseURL + "/get_insurers", {
      credentials: "include",
    });
    const data = await res.json();
    console.log(data);
    this.insurers = data;
    const form = document.getElementById("form_id");
    form.addEventListener(
      "submit",
      function(event) {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add("was-validated");
      },
      false
    );
    this.loading = false;
  },
  computed: {
    // resultQuery() {
    //   if (
    //     this.qdescSearchQuery ||
    //     this.qcodeSearchQuery ||
    //     this.icodeSearchQuery ||
    //     this.idescSearchQuery ||
    //     this.inameSearchQuery
    //   ) {
    //     return this.rulesets.filter((ruleset) => {
    //       return (
    //         this.qdescSearchQuery
    //           .toLowerCase()
    //           .split(" ")
    //           .every((v) =>
    //             ruleset.quotey_description.toLowerCase().includes(v)
    //           ) &&
    //         this.qcodeSearchQuery
    //           .split(" ")
    //           .every((v) => ruleset.quotey_code.includes(v)) &&
    //         this.icodeSearchQuery
    //           .split(" ")
    //           .every((v) => ruleset.insurer_code.includes(v)) &&
    //         this.idescSearchQuery
    //           .split(" ")
    //           .every((v) =>
    //             ruleset.insurer_description.toLowerCase().includes(v)
    //           ) &&
    //         this.inameSearchQuery
    //           .split(" ")
    //           .every((v) => ruleset.insurer_name.includes(v))
    //       );
    //     });
    //   } else {
    //     return this.rulesets;
    //   }
    // },
    searchQuery() {
      return `${this.qdescSearchQuery}|${this.qcodeSearchQuery}|${this.icodeSearchQuery}|${this.idescSearchQuery}|${this.inameSearchQuery}`;
    },
  },
};
</script>

<style scoped>
.divider {
  width: 5px;
  height: auto;
  display: inline-block;
}
.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  -webkit-transition-property: height, visibility;
  transition-property: height, visibility;
  -webkit-transition-duration: 0.6s;
  transition-duration: 0.6s;
  -webkit-transition-timing-function: ease;
  transition-timing-function: ease;
}
.spinner-border {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5%;
}
</style>
